import React from 'react';
import Badge from '../Badge';
import { STATUS_LABELS, STATUS_VARIANTS } from './constants';

interface StatusBadgeProps {
  status: string;
  /** Etichette alternative (vista richiedente associato/ospite). */
  labels?: Record<string, string>;
  /** Pallino a sinistra: usato nelle pagine richiedente. */
  dot?: boolean;
}

// Badge di stato del ticket: unica fonte per etichette e varianti colore.
const StatusBadge: React.FC<StatusBadgeProps> = ({ status, labels = STATUS_LABELS, dot }) => (
  <Badge variant={STATUS_VARIANTS[status] || 'secondary'} size="small" dot={dot}>
    {labels[status] || status}
  </Badge>
);

export default StatusBadge;
